import React, { useState } from 'react'
import "../App.css";
import "./MobileNav.css";
import { IconContext } from "react-icons";
import { IoMdArrowDropdown } from "react-icons/io";



const MobileNav = () => {
  const [activeId, setActiveId] = useState("");

  const handleClick = (id) => {
    setActiveId(id);
  };







  function dropandrotate() {

    const toggleButton = document.querySelector('.togglebutton');
    toggleButton.classList.toggle('open');
    const navpopup = document.querySelector(".navpopup")
    navpopup.classList.toggle('open');

  }








  return (
    <>
      <div className=' mobnav'>

        <div className="leftmobnav">
          <div className="leftnavimgdiv">
            <img className="navleftimg" src="/assets/Grid.png" />
          </div>
        </div>


        <div className="rightmobnav">

       

          <div className="togglebutton" onClick={dropandrotate}>
            <span className='Lone'></span>
            <span className='Ltwo'></span>
            <span className='Lthree'></span>
          </div>

        </div>

        <div className='margincontainer navpopup'>


          <li className="navitems2">
            <a className="anavbarheadings" href="/home">Home
            </a>
          </li>




          <li className="navitems2">
          <a className="anavbarheadings" href="/pl">Prime Location
          </a>
          </li>


          <li className="navitems2">
          <a className="anavbarheadings" href="/bs">Best Sellers
          </a>
          </li>

          <li className="navitems2" >
          <a className="anavbarheadings" href="/inv">Investment
          </a>
          </li>

          <li className="navitems2">
          <a className="anavbarheadings" href="/com">Commercials
          </a>
          </li>

          <li className="navitems2">
          <a className="anavbarheadings" href="/contact">Contact Us
          </a>
          </li>

        </div>





      </div>


    </>
  )
}

export default MobileNav


